import { IValueAddedServiceInitialState } from "../../../types/master/valueAddedServiceInterface";
import {
  ValueAddedServiceActionTypes,
  ValueAddedServiceActions,
} from "../../actionTypes/master/valueAddedServiceActionTypes";

const initialState: IValueAddedServiceInitialState = {
  valueAddedServiceList: [],
};

export default function valueAddedServiceReducer(
  state = initialState,
  action: ValueAddedServiceActionTypes
): IValueAddedServiceInitialState {
  switch (action.type) {
    case ValueAddedServiceActions.SET_VALUE_ADDED_SERVICE_LIST:
      return {
        ...state,
        valueAddedServiceList: action.payload,
      };

    default:
      return state;
  }
}
